// extracted by mini-css-extract-plugin
export default {"container":"XSE5K","title-section":"x2TX2","body-section":"Vl5uh"};